import { SmartSuggestRendering } from 'PyzShopUi/scripts/search-suggestion/includes/rendering/SmartSuggestRendering';
import { SearchSuggestionRendering } from 'PyzShopUi/scripts/search-suggestion/includes/rendering/SearchSuggestionRendering';
import { isSmartSuggestEnable } from 'PyzShopUi/scripts/search-suggestion/includes/searchSuggestionHelper';

export default class SearchSuggestionHandler {
    public static init = (): void => {
        const searchFormElement: HTMLFormElement = document.querySelector('#article-search');
        const searchSuggestionElement: HTMLElement = document.querySelector('#search-suggestion');

        if (!searchSuggestionElement || !searchFormElement) {
            return;
        }

        if (isSmartSuggestEnable()) {
            new SmartSuggestRendering(searchSuggestionElement, searchFormElement);

            return;
        }

        new SearchSuggestionRendering(searchSuggestionElement, searchFormElement);
    };
}
